// extracted by mini-css-extract-plugin
export default {"title":"Full_title__36q8R","transferItem":"Full_transferItem__30iVB","label":"Full_label__2RLg-","content":"Full_content__2Fglt"};